import {
  FETCH_DELIVERY_TIME,
  DELIVERY_TIME_LOADING,
  UPDATE_PROMOTION,
} from "./actionTypes";
import instance from "./instance";
import { edit_quantity, remove_from_cart, updatePromotions } from "./cart";
import { calculate_prep_time } from "../reducers/cart";
import { getEffectiveLegacyCartItems } from "../../checkout-v2/domain/cartContext";
import { isCheckoutV2Eligible } from "../../checkout-v2/domain/featureFlags";
import deliveryTimeReducer from "../reducers/deliveryTime";

export const buildEffectiveDeliveryTimeCart = (cart = {}, validation = {}) => {
  const regularItems = Array.isArray(cart.cart) ? cart.cart : [];
  const promoItems = Array.isArray(cart.promo_items) ? cart.promo_items : [];
  return {
    ...cart,
    cart: getEffectiveLegacyCartItems(regularItems, validation),
    promo_items: getEffectiveLegacyCartItems(
      promoItems,
      validation,
      regularItems.length
    ),
  };
};

export const isCheckoutV2DeliveryTimeEnabled = (state = {}) => {
  const settings = state.store?.store?.settings || {};
  const address = state.customers?.address || {};
  const pathname =
    typeof window === "undefined" ? "" : window.location?.pathname || "";
  return isCheckoutV2Eligible(settings, {
    address,
    cart: state.cart,
    pathname,
  });
};

export const fetchDeliveryTime = (options = {}) => {
  return async (dispatch, getState) => {
    const commit = options.commit !== false;
    let preview = null;
    try {
      const state = getState();
      const cart = state.cart;
      const settings = state.store.store.settings;
      const selectedFulfilmentType = state.deliveryTime.type;
      const checkoutV2 = isCheckoutV2DeliveryTimeEnabled(state);
      const requestCart = checkoutV2
        ? buildEffectiveDeliveryTimeCart(
            cart,
            state.checkoutV2?.cartValidation || {}
          )
        : cart;
      let isPickup;
      let branch = null;
      let bdc = null;
      let pickupBranchStoreBased = null;
      if (settings.is_branch_based_ordering) {
        if (getState().branch.isPickup) isPickup = true;
        else isPickup = false;

        branch = getState().branch.branch;
        bdc = getState().branch.bdc;
        if (!branch) return;
      } else {
        if (getState().customers.address) {
          if (getState().customers.address.selectedDeliveryType == 1) {
            isPickup = true;
            pickupBranchStoreBased = getState().customers.address.pickupArea;
          } else isPickup = false;
        } else isPickup = true;
      }
      dispatch({ type: DELIVERY_TIME_LOADING, payload: true });
      const requestPayload = {
        prep_time: calculate_prep_time(
          [...requestCart.cart, ...requestCart.promo_items],
          settings.sum_product_prep_time
        ),
        is_pickup: isPickup,
        branch: branch,
        bdc: bdc,
        cart: requestCart,
        pickupBranchStoreBased: pickupBranchStoreBased,
        country: getState().customers?.address?.country,
        area: getState().customers?.address?.area,
      };
      if (checkoutV2) requestPayload.checkout_v2 = true;
      const res = await instance.post("/get_delivery_time/", requestPayload);

      if (res.data.changeQuantities && !checkoutV2) {
        EditQuantities(res.data.changeQuantities, cart, dispatch);
      } else if (res.data) {
        const deliveryTimePayload = { ...res.data, isPickup: isPickup };
        if (commit)
          dispatch({
            type: FETCH_DELIVERY_TIME,
            payload: deliveryTimePayload,
          });
        else
          preview = deliveryTimeReducer(getState().deliveryTime, {
            type: FETCH_DELIVERY_TIME,
            payload: deliveryTimePayload,
          });
        if (commit && !selectedFulfilmentType) {
          dispatch(updatePromotions());
        }
      }
    } catch (err) {
      console.error(err);
    }
    dispatch({ type: DELIVERY_TIME_LOADING, payload: false });
    // Callers such as checkout quote recovery need the reducer-normalized
    // selection (including a freshly issued ASAP authority), not the raw
    // delivery-time response.
    return preview || getState().deliveryTime;
  };
};

const EditQuantities = (products, cart, dispatch) => {
  let quantityToBeDeducted;
  let removedProducts;

  for (const product_id in products) {
    const ProductQuantities = {};
    let ProductTotal = 0;
    removedProducts = 0;
    cart.cart.forEach((prod, index) => {
      if (
        prod.id == product_id &&
        (!products[product_id].is_preordered ||
          products[product_id].is_preordered === prod.is_preordered)
      ) {
        ProductQuantities[index] = prod.quantity;
        ProductTotal += prod.quantity;
      }
    });
    quantityToBeDeducted = ProductTotal - products[product_id].max;

    for (const product in ProductQuantities) {
      if (
        products[product_id].is_preordered ||
        ProductQuantities[product] <= quantityToBeDeducted
      ) {
        dispatch(
          remove_from_cart(
            product - removedProducts,
            cart.cart[product],
            false,
            products[product_id].is_preordered
          )
        );
        quantityToBeDeducted -= ProductQuantities[product];
        ProductTotal -= ProductQuantities[product];
        removedProducts += 1;
      } else if (quantityToBeDeducted > 0) {
        dispatch(
          edit_quantity(
            parseInt(product - removedProducts),
            cart.cart[product],
            ProductQuantities[product] - quantityToBeDeducted,
            -quantityToBeDeducted,
            false,
            cart.cart[product].is_preordered,
            products[product_id].max
          )
        );
      }
    }
  }

  dispatch({ type: "SHOW_CHECK_CART" });
  dispatch(fetchDeliveryTime());
};

export const setDrawer = (state) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "SET_DELIVERY_TIME_DRAWER", payload: state });
    } catch (err) {
      console.error(err);
    }
  };
};
